var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbiddenData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 68,
    viewBox: "0 0 96 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.848 12.2393C6.75427 12.2393 2.74401 16.2827 3.14792 21.0115L5.49125 48.2829C5.85348 52.505 9.63935 55.7593 14.1914 55.7593H81.808C86.3568 55.7593 90.1427 52.505 90.5081 48.2829L92.8514 21.0115C93.2585 16.286 89.2451 12.2393 84.1513 12.2393H11.848Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8139 38.8927C27.1237 38.8927 26.5593 38.3317 26.5593 37.6381V7.37472C26.5593 6.68452 27.1237 6.12012 27.8139 6.12012H42.0871C42.4237 6.12012 42.7501 6.25952 42.9847 6.50092L46.8539 10.4823H69.5251C70.2153 10.4823 70.7797 11.0433 70.7797 11.7369V37.6415C70.7797 38.3317 70.2153 38.8961 69.5251 38.8961H27.8105L27.8139 38.8927Z",
    fill: "#EBEBEB",
    stroke: "#999999",
    strokeWidth: 0.68
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7946 58.3917C24.9718 58.3917 24.2986 57.7219 24.2986 56.8957V15.0077C24.2986 14.1849 24.9684 13.5117 25.7946 13.5117H42.4818C42.883 13.5117 43.274 13.6783 43.5528 13.9673L48.068 18.6117H74.5574C75.3802 18.6117 76.0534 19.2815 76.0534 20.1077V56.8991C76.0534 57.7219 75.3836 58.3951 74.5574 58.3951H25.7946V58.3917Z",
    fill: "#C2C2C2",
    stroke: "#999999",
    strokeWidth: 0.68
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.253 43.0479H54.4736C54.0136 43.0479 53.6406 43.4208 53.6406 43.8809V53.0745C53.6406 53.5345 54.0136 53.9075 54.4736 53.9075H70.253C70.7131 53.9075 71.086 53.5345 71.086 53.0745V43.8809C71.086 43.4208 70.7131 43.0479 70.253 43.0479Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6048 44.9705V37.8763C29.6048 35.6389 27.7886 33.8172 25.558 33.8172C23.3274 33.8172 21.5112 35.6389 21.5112 37.8763V44.9705H18.2966V37.8797C18.2966 33.8645 21.5516 30.5996 25.5546 30.5996C29.5576 30.5996 32.8126 33.8645 32.8126 37.8797V44.9739H29.5981L29.6048 44.9705Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 0.68
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7186 44.1836H18.4014C17.4728 44.1836 16.72 44.9387 16.72 45.8701V60.1937C16.72 61.1251 17.4728 61.8802 18.4014 61.8802H32.7186C33.6472 61.8802 34.4 61.1251 34.4 60.1937V45.8701C34.4 44.9387 33.6472 44.1836 32.7186 44.1836Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 0.68
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5614 56.9689C25.0391 56.9689 24.6112 56.5431 24.6112 56.0158V53.7446L24.5236 53.6973C23.7722 53.2849 23.3342 52.4603 23.4117 51.6018C23.506 50.5473 24.3686 49.7024 25.4233 49.6381C25.4704 49.6381 25.5143 49.6348 25.5614 49.6348C26.7509 49.6348 27.7213 50.6048 27.7213 51.8012C27.7213 52.5921 27.29 53.3187 26.5992 53.7007L26.5116 53.748V56.0192C26.5116 56.5431 26.0871 56.9723 25.5614 56.9723V56.9689Z",
    fill: "#C2C2C2",
    stroke: "#999999",
    strokeWidth: 0.68
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8198 47.7425C19.4592 47.7425 19.1694 47.4485 19.1694 47.0869C19.1694 46.7252 19.4626 46.4346 19.8198 46.4346C20.1769 46.4346 20.4701 46.7286 20.4701 47.0869C20.4701 47.4451 20.1769 47.7425 19.8198 47.7425Z",
    fill: "#C2C2C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3034 47.7425C30.9429 47.7425 30.6531 47.4485 30.6531 47.0869C30.6531 46.7252 30.9462 46.4346 31.3034 46.4346C31.6606 46.4346 31.9537 46.7286 31.9537 47.0869C31.9537 47.4451 31.6606 47.7425 31.3034 47.7425Z",
    fill: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7013 29.9197C78.1402 29.9197 83.3599 24.7 83.3599 18.2611C83.3599 11.8223 78.1402 6.60254 71.7013 6.60254C65.2625 6.60254 60.0427 11.8223 60.0427 18.2611C60.0427 24.7 65.2625 29.9197 71.7013 29.9197Z",
    fill: "#7A7A7A"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5385 28.7576C76.9773 28.7576 82.1971 23.5379 82.1971 17.099C82.1971 10.6602 76.9773 5.44043 70.5385 5.44043C64.0996 5.44043 58.8799 10.6602 58.8799 17.099C58.8799 23.5379 64.0996 28.7576 70.5385 28.7576Z",
    fill: "#7A7A7A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5384 20.5601C69.7326 20.5601 69.0798 19.9073 69.0798 19.1015V10.5641C69.0798 9.75827 69.7326 9.10547 70.5384 9.10547C71.3442 9.10547 71.997 9.75827 71.997 10.5641V19.1015C71.997 19.9073 71.3442 20.5601 70.5384 20.5601Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5384 25.0885C69.7326 25.0885 69.0798 24.4357 69.0798 23.6299V23.6129C69.0798 22.8071 69.7326 22.1543 70.5384 22.1543C71.3442 22.1543 71.997 22.8071 71.997 23.6129V23.6299C71.997 24.4357 71.3442 25.0885 70.5384 25.0885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbiddenData);
export default __webpack_public_path__ + "static/media/forbidden-data.2690fc097376c4be098eb0cd328d05f0.svg";
export { ForwardRef as ReactComponent };